/** Normalise une requête de filtre sur liste (insensible à la casse). */
export function listSearchQuery(q) {
  return String(q ?? "").trim().toLowerCase();
}

/**
 * Retourne true si la requête est vide ou si le texte concaténé contient la requête.
 * @param {string} query
 * @param  {...(string|number|null|undefined|(string|number)[])} textParts
 */
export function matchListSearch(query, ...textParts) {
  const q = listSearchQuery(query);
  if (!q) return true;
  const haystack = textParts
    .flatMap((p) => (Array.isArray(p) ? p : [p]))
    .filter((x) => x != null && x !== "")
    .map((x) => String(x))
    .join(" ")
    .toLowerCase();
  return haystack.includes(q);
}
